/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatachangeMultiDataField } from './datachangeMultiDataField';


/**
 * datachange the data that can be edited
 */
export interface DatachangeMultiData { 
    /**
     * identifier for the individual entries (datachange_multi_data -> key depends on -> datachange_multi_metadata -> id_field)
     */
    id: number;
    dataFields: Array<DatachangeMultiDataField>;
}

